module.exports = __webpack_public_path__ + "img/font-weight.7b62a475.svg";